<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Contact</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section-lg contact">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="form-bg bg-lightblue p-3">
                    <div class="npf_wgts" data-height="480px" data-w="5ac66c069923a6ba49784ed2f69cd313"></div>
                    <!-- <div class="npf_wgts" data-height="480px" data-w="6e2d938a8f42987637737ee22606670f"></div>  -->
                    <!-- <iframe src="https://ghrccst.raisoni.net/php_pages/contact.php" width="100%" height="400px" allowTransparency="true"  frameborder="0"></iframe> -->
                    <!-- <div class="form-container">
                        <form class="form-horizontal">
                            <div class="form-group">
                                <span class="input-icon"><i class="fa fa-user"></i></span>
                                <input class="form-control" type="name" placeholder="Name">
                            </div>
                            <div class="form-group">
                                <span class="input-icon"><i class="fa fa-envelope"></i></span>
                                <input class="form-control" type="email" placeholder="Email">
                            </div>
                            <div class="form-group">
                                <span class="input-icon"><i class="fa fa-phone"></i></span>
                                <input class="form-control" type="mobile" placeholder="Mobile">
                            </div>
                            <div class="form-group">
                                <span class="input-icon"><i class="fa fa-edit"></i></span>
                                  <textarea class="form-control" placeholder="Message" required></textarea>
                            </div>
                            <div class="text-center mt-4">
                                <button class="button-text" input type="submit" href="#">Submit</button>
                            </div>
                        </form>
                    </div> -->
                </div>
            </div>
            <div class="col-md-6">
                <div class="contact-info">
                    <div class="icon"><i class="fa fa-map-marker"></i>
                    </div>
                    <div class="details"><a href="javascript:void(0);" class="text-dark"> Riaan Tower, Rangilal Marg,
                            Near Mangalwari Bazaar, Sadar - 440001</a></div>
                </div>
                <div class="contact-info">
                    <div class="icon"><i class="fa fa-phone"></i></div>
                    <div class="details"><a href="tel:8669950061" class="text-dark"><span>
                                Contact No.</span><br>07126617181, +91 9307900682</a></div>
                </div>
                <div class="contact-info">
                    <div class="icon"><i class="fa fa-envelope-o"></i>
                    </div>
                    <div class="details"><a href="mailto:ghrccstnag@raisoni.net"
                            class="text-dark">ghrccstnag@raisoni.net</a> <br>
                            <a href="mailto:info@raisoni.net"
                            class="text-dark">info@raisoni.net</a>
                            
                    </div>
                </div>
                <div class="contact-info">
                    <div class="icon"><i class="fa fa-phone"></i></div>
                    <div class="details"><a href="tel:8669950061" class="text-dark"><span>
                               Admission Enquiry - </span><br>9307900681 /  9307900682</a></div>
                </div>
            </div>
            <!-- <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.6996527840383!2d79.07928437401343!3d21.164347783110202!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c1ce49a20ae7%3A0x60c344108878a522!2sG%20H%20Raisoni%20College%2C%20Riaan%20tower!5e0!3m2!1sen!2sin!4v1718106607069!5m2!1sen!2sin"
                    width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe> -->

            <!-- <img src="assets/images/helpline.webp" alt="" title=""> -->

        </div>
    </div>
</section>

<!-- <section class="section-lg std-scholarship">
    <div class="container">
        <div class="inner-title">
            <h3>Raisoni Group Admission in Charge 2025-26</h3>

        </div>
        <div class="table-responsive">
            <table class="table table-bordered text-center tbl_custom">
                <thead>
                    <tr>
                        <th>Location</th>
                        <th>Admission Incharge</th>
                        <th>Contact Number</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Admission cell, Nagpur</td>
                        <td>Mrs. Nidhi Kurda</td>
                        <td><a href="tel:9307900682"> 9307900682</a></td>
                    </tr>
                    <tr>
                        <td>Admission cell, Nagpur</td>
                        <td>Mr. Dhammadip Shingade</td>
                        <td><a href="tel:8975862424">8975862424</a></td>
                    </tr>
                    <tr>
                        <td>Admission cell, Nagpur</td>
                        <td>Mr. Samyak Raj</td>
                        <td><a href="tel:8287810035">8287810035</a></td>
                    </tr>
                    <tr>
                        <td>Admission cell, GHRU, Saikheda</td>
                        <td>Prof. Adheer A.Goyal</td>
                        <td><a href="tel:8446640020">8446640020</a></td>
                    </tr>
                    <tr>
                        <td>Admission cell, GHRU, Saikheda</td>
                        <td>Mr. Bharat Bhargava</td>
                        <td><a href="tel:9860454944">9860454944</a></td>
                    </tr>
                    <tr>
                        <td>Admission cell, GHRU, Amravati</td>
                        <td>Mr. Manish Awasthi</td>
                        <td><a href="tel:9657724126">9657724126</a></td>
                    </tr>
                    <tr>
                        <td>Admission cell, GHRU, Amravati</td>
                        <td>Mr. Kishor Watane</td>
                        <td><a href="tel:9422377963">9422377963</a></td>
                    </tr>
                    <tr>
                        <td>Admission cell, GHRU, Amravati</td>
                        <td>Mr. Pavan Ambulkar</td>
                        <td><a href="tel:7391079473">7391079473</a></td>
                    </tr>
                    <tr>
                        <td>Admission cell, Jalgaon</td>
                        <td>Mr. Rafik Shaikh</td>
                        <td><a href="tel:9823337862">9823337862</a></td>
                    </tr>
                    <tr>
                        <td>Admission cell, Jalgaon</td>
                        <td>Mr. Ganesh Patil</td>
                        <td><a href="tel:9623450636">9623450636</a></td>
                    </tr>
                    <tr>
                        <td>Admission cell, Pune</td>
                        <td>Ms. Amita Singh</td>
                        <td><a href="tel:8605625522">8605625522</a></td>
                    </tr>
                    <tr>
                        <td>Admission Cell,Junior Colleges (State & Cbse)</td>
                        <td>Mr. Amandeep Singh Rajput</td>
                        <td><a href="tel:7030049839 ">7030049839 </a></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="inner-title">
            <h3>City Offices</h3>

        </div>
   <table class="table table-bordered text-center tbl_custom">
    <thead>
        <tr>
            <th class="text-center" width="5%">SR.NO.</th>
            <th class="text-center" width="35%">MARKETING EXECUTIVE NAME</th>
            <th class="text-center" width="10%">DESIGNATION</th>
            <th class="text-center" width="8%">CONTACT</th>
            <th class="text-center" width="8%">CITY</th>
            <th class="text-center" width="20%">ADDRESS</th>
            <th class="text-center" width="5%">EMAIL ID</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="text-center">1</td>
            <td class="text-center">Rajwardhan Damodar / Chetan Gawai</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7391098119 / 9403172285</td>
            <td class="text-center">Akola</td>
            <td class="text-center">Near Gajanan Hospital, Int. of Sharda Udyog (Necklace Road), Akola-444001</td>
            <td class="text-center">rajwardhan.damodar@raisoni.net / chetan.gawai@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">2</td>
            <td class="text-center">Sandesh Jadhao</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7391079436</td>
            <td class="text-center">Buldhana</td>
            <td class="text-center">Raut mangal karyalaya, Infront of Bal Shivaji school, Circular road, Buldhana 443001</td>
            <td class="text-center">sandesh.jadhav@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">3</td>
            <td class="text-center">Rakesh Rakhade / Shoeb Pathan</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7391079434 / 7249464677</td>
            <td class="text-center">Bhandara</td>
            <td class="text-center">2nd Floor, Vijaylaxmi Building, Bikaner Road, Tuition Galli, Rajiv Gandhi Chowk, Bhandara</td>
            <td class="text-center">rakesh.rakhade@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">4</td>
            <td class="text-center">Rahul Zanke / Karan Borewar</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7391079440 / 7030252767</td>
            <td class="text-center">Chandrapur</td>
            <td class="text-center">Sai heritage, Building 2nd floor, c/o Sairam enterprises, Warora Naka Chandrapur 442401</td>
            <td class="text-center">rahul.zanke@raisoni.net / karan.borewar@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">5</td>
            <td class="text-center">Hitesh Bhele / Siddhant Moon</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030246781 / 7391049948</td>
            <td class="text-center">Wardha</td>
            <td class="text-center">Shop no.18, Shivarpan complex, Arvi naka, Wardha - 442001</td>
            <td class="text-center">hitesh.bhele@raisoni.net / siddhant.moon@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">6</td>
            <td class="text-center">Pankaj Badoley / Sachin Shedmake</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030246798 / 7030007459</td>
            <td class="text-center">Gadchiroli</td>
            <td class="text-center">C/O Kusumbai Katwale, Chamorshi Road, Gadchiroli, PL No. 13/109, Pin Code 442605</td>
            <td class="text-center">pankaj.badoley@raisoni.net / sachin.shedmake@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">7</td>
            <td class="text-center">Raj Dahiwade</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030252726</td>
            <td class="text-center">Yavatmal</td>
            <td class="text-center">C/O of Aarya Finical Super Bajar Complex, Near Shiv Shakti Lawn, Dhanmangaon road Yavatmal - 445001</td>
            <td class="text-center">rajesh.dahiwade@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">8</td>
            <td class="text-center">Mohan Biyani / Danish khan</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030246796 / 7030058760</td>
            <td class="text-center">Washim</td>
            <td class="text-center">Paras Plaza No 1, Shop No 8, Below HDFC Bank, Risod Road, Washim 444505</td>
            <td class="text-center">mohan.biyani@raisoni.net / danish.khan@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">9</td>
            <td class="text-center">Swapnil Sahare</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7875502673</td>
            <td class="text-center">Gondia</td>
            <td class="text-center">Raisoni Education,1st floor Shri sai complx Near New Bus Stand, Balaghat Road, Marartoli, Gondia-441614</td>
            <td class="text-center">swapnil.sahare@raisoni</td>
        </tr>
        <tr>
            <td class="text-center">10</td>
            <td class="text-center">Shubham Gupta</td>
            <td class="text-center">Academic Counsellor</td>
            <td class="text-center">7498919242</td>
            <td class="text-center">Warud (Amravati)</td>
            <td class="text-center">Shop Number 5, Tuljai Complex, Near Kasikar Hospital, Renuka Nagar, Warud-444906</td>
            <td class="text-center">shubham.gupta@ghrua.edu.in</td>
        </tr>
        <tr>
            <td class="text-center">11</td>
            <td class="text-center">Prathamesh Bhusari</td>
            <td class="text-center">Academic Counsellor</td>
            <td class="text-center">7767004719</td>
            <td class="text-center">Paratwada (Amravati)</td>
            <td class="text-center">Shop No. 9, Gulhane Complex, Near Kamal Agrawal Hospital, Achalpur Road, Paratwada 444805</td>
            <td class="text-center">prathamesh.bhusari@ghrua.edu.in</td>
        </tr>
        <tr>
            <td class="text-center">12</td>
            <td class="text-center">Niranjan Raghuwanshi</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7391079435</td>
            <td class="text-center">Chhindwara</td>
            <td class="text-center">Raisoni Education, Shop No. M-3 (Mezzanine Floor), Mansarover Commercial Complex, Near Bus Stand, Chhindwara (M.P.)</td>
            <td class="text-center">niranjan.raghuwanshi@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">13</td>
            <td class="text-center">Devilal Pawar</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7391079441</td>
            <td class="text-center">Pandhurna</td>
            <td class="text-center">Kekatpure Complex, Beside Punjab National Bank, In front of Rest House, Pandhurna</td>
            <td class="text-center">devilal.pawar@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">14</td>
            <td class="text-center">Manmohan Gire</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7828908733</td>
            <td class="text-center">Sausar</td>
            <td class="text-center">Gawandhe Complex, Near Sai Mandir, Beside Indian Furniture, Sausar</td>
            <td class="text-center">manmohan.gire@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">15</td>
            <td class="text-center">Mangalmurti Kanathe</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030246785</td>
            <td class="text-center">Betul</td>
            <td class="text-center">-</td>
            <td class="text-center">mangalmurti.kanathe@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">16</td>
            <td class="text-center">Mohan Bavistale</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030246854</td>
            <td class="text-center">Balaghat</td>
            <td class="text-center">-</td>
            <td class="text-center">mohan.bavistale@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">17</td>
            <td class="text-center">Bharat Patil</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030093216</td>
            <td class="text-center">Dhule</td>
            <td class="text-center">Shop No. 4, Navakar Dreams, Sharda Nagar, Bhoi Society, Opp SBI ATM, Swaminarayan Road, Dattamandir, Dhule - 424002</td>
            <td class="text-center">bharat.patil@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">18</td>
            <td class="text-center">Shaikh Ateeque Ur Rehman / Vijay Dabade</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030065979 / 7030252697</td>
            <td class="text-center">Aurangabad</td>
            <td class="text-center">Raisoni Education, Plot No. 10, Sushil Co-Opp Housing Society, Shreya Nagar Road, Osmanpura, Aurangabad - 431005 (Landmark: Vaidya Children Hospital Osmanpura)</td>
            <td class="text-center">ateeque.shaikh@raisoni.net / vijay.dabhade@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">19</td>
            <td class="text-center">Dhananjay Parasharam Shivatnkar</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030007494</td>
            <td class="text-center">Kolhapur</td>
            <td class="text-center">Raisoni Education, Near Purandar Misal, Rajarampuri 7th Lane, Kolhapur MH-416001</td>
            <td class="text-center">dhananjay.shivatnkar@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">20</td>
            <td class="text-center">Rameshwar S Mutkule / Rahul Jagtap</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030057095 / 7391043285</td>
            <td class="text-center">Beed</td>
            <td class="text-center">Raisoni Education, Gala No. 22, Umakiran Complex, Pangiri Road, Shahunagar, Beed MH-431122</td>
            <td class="text-center">rameshwar.mutkule@raisoni.net / rahul.jagtap@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">21</td>
            <td class="text-center">Aamir Sheikh</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7767004718</td>
            <td class="text-center">Latur</td>
            <td class="text-center">Ward No. D1, Milkat Kramank 1470, Ambajogai Road, Venkatesh Nagar, Opp. Amba Hanuman Mandir, Latur-413512</td>
            <td class="text-center">aamir.sheikh@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">22</td>
            <td class="text-center">Santosh Tawade / Harshad Gautam Gaware</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030246831 / 7391043280</td>
            <td class="text-center">Nanded</td>
            <td class="text-center">Shop No. 2, Uday Nagar, Near Talware Mathematic Classes, Bhagya Nagar T Point, Nanded 431602</td>
            <td class="text-center">santosh.tawade@raisoni.net / harshad.gaware@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">23</td>
            <td class="text-center">Aamir Sheikh</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7767004718</td>
            <td class="text-center">Ahmednagar</td>
            <td class="text-center">G H Raisoni College of Engineering and Management, Gate No.1030, Pune Highway, Village Chass, Jilha Parishad, Ahilya Nagar, MH 414008</td>
            <td class="text-center">aamir.sheikh@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">24</td>
            <td class="text-center">Deepak Shinde</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">7030246845</td>
            <td class="text-center">Parbhani</td>
            <td class="text-center">Raisoni Education, Jaishree Vishwanath Salve, Venkatesh Nagar, Ganpati Mandir, Deshmukh Hotel, Karegaon Road, Parbhani 431401</td>
            <td class="text-center">deepak.shinde@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">25</td>
            <td class="text-center">Karan Shrivastav</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">9122882610</td>
            <td class="text-center">Patna</td>
            <td class="text-center">-</td>
            <td class="text-center">karan.shrivastav@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">26</td>
            <td class="text-center">Bharat Bhargava</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">9860454944</td>
            <td class="text-center">Hyderabad</td>
            <td class="text-center">-</td>
            <td class="text-center">ambadipudi.saishyam@raisoni.net</td>
        </tr>
        <tr>
            <td class="text-center">27</td>
            <td class="text-center">Vikrant Sahu</td>
            <td class="text-center">Sr. Academic Counsellor</td>
            <td class="text-center">9926755384</td>
            <td class="text-center">Bilaspur</td>
            <td class="text-center">1st Floor, Shop No. 11, Ambe Trade Center, Link Road, Beside C.M.D College Ground, Bilaspur - Chhattisgarh 495001</td>
            <td class="text-center">vikrant.sahu@raisoni.net</td>
        </tr>
    </tbody>
</table>

    </div>
</section> -->
<!-- <div class="text-center">
    <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3722.6824335426763!2d78.9898602149336!3d21.085342185967708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4953155555555%3A0xf029a2c3bb6e65d6!2sG.H.%20Raisoni%20School%20of%20Business%20Management!5e0!3m2!1sen!2sin!4v1621674549458!5m2!1sen!2sin"
        width="100%" height="550" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
</div> -->